<section class="grid-x">
  <div class="container">
    <div class="blog__content grid-x">
      <div class="cell large-8" [routerLink]="['/news', article().id]">
        <h3 class="center-text">{{article().attributes.title}}</h3>
        <p class="center-text">{{article().attributes.summary}}</p>
      </div>
      <div class="cell large-4">
        <div class="blog__image" [ngStyle]="{'background-image': 'url(' + (image | async) + ')'}"></div>
      </div>
    </div>
    @if (editMode()) {
      <div class="edit-buttons">
        <button class="button" (click)="editArticle()">edit</button>
        <button class="button" (click)="deleteArticle()">delete</button>
      </div>
    }
  </div>
</section>
